import React, { Component } from 'react';

import Add from './add';
import Edit from './edit';
import Loading from '../../loading';
import Server from '../../../functions/server'
import $ from "jquery";


class Info extends Component {

  state = {
    data: null,
    load: false,
    message: '',
    partno: 0
  }

  componentDidMount() {
    this.getInfo();
  }

  componentDidUpdate(props) {
    if (props.partno != this.props.partno) {
      this.getInfo();
    }
  }

  getInfo() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Spares Info!!!',
      partno: this.props.partno
    });
    let data1 = {'partno': this.props.partno};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/getinfo.php',
      success: function(data)
      {
        console.log(data);
        try {
          data = JSON.parse(data);
          console.log(data);
          console.log('here data');
          if (data.length >= 1) {
            context.setState({
              load: false,
              data: data,
            });
          }
          else {
            context.setState({
              load: false,
              data: null,
            });
          }
        } catch (e) {
          context.setState({
            load: false,
          });
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  render() {
    let i = 0;
    let { load, message } = this.state;
    let loading;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    let edit = (<div></div>);
    if (this.state.data) {
      edit = this.state.data.map((z) => {
        if (i == 0) {
          i++;
          return (
            <Edit partno={this.props.partno} partsedit={this.props.partsedit}  data={z} title={this.props.title}
               getInfo={this.getInfo.bind(this)} />
          )
        }
      })
    }
    return (
      <div>
        {
          this.state.data ?
          (<div>{edit}</div>) :
          (<div><Add partno={this.props.partno} title={this.props.title} partsedit={this.props.partsedit} /></div>) }
        {loading}
      </div>
    );
  }
}

export default Info;
